export const documentSlugs = {
    conditions: 'vseobecne-obchodni-podminky',
    regulations: 'navstevni-rad',
    personalData: 'podminky-zpracovani-osobnich-udaju',
    loyaltyProgram: 'podminky-clenstvi-cinestar-clubu',
    addsNews: 'souhlas-se-zasilanim-obchodnich-sdeleni-partneru-cinestar',
}
